import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DEAL_DESK_URL } from "../environments/environment";
import { Observable } from "rxjs";
import { ResponseDealDesk, ResponseDealDeskListItem } from "../types/dai-server/deal-desk/deal-desk-responses";
import { RequestCreateDealDesk, RequestUpdateDealDeskStatus } from "../types/dai-server/deal-desk/deal-desk-requests";
import { DealDeskStatus, dealDeskStatusSlug } from "../types/dai-server/deal-desk/enums";

@Injectable({
    providedIn: 'root'
})
export class DealDeskService {
    private apiUrl = DEAL_DESK_URL;

    constructor(private http: HttpClient) { }

    createDealDesk(request: RequestCreateDealDesk): Observable<ResponseDealDesk> {
        return this.http.post<ResponseDealDesk>(`${this.apiUrl}`, request);
    }

    getDealDesks(): Observable<ResponseDealDeskListItem[]> {
        return this.http.get<ResponseDealDeskListItem[]>(`${this.apiUrl}`);
    }

    getDealDesk(id: string): Observable<ResponseDealDesk> {
        return this.http.get<ResponseDealDesk>(`${this.apiUrl}/${id}`);
    }

    updateDealDeskStatus(id: string, update: RequestUpdateDealDeskStatus): Observable<ResponseDealDesk> {
        return this.http.post<ResponseDealDesk>(`${this.apiUrl}/${id}/status`, update);
    }

    reviewDealDesk(id: string, decision: DealDeskStatus, token: string): Observable<void> {
        const body = new FormData();
        body.append('token', token);
        return this.http.post<void>(`${this.apiUrl}/review/${id}/${dealDeskStatusSlug(decision)}`, body);
    }
}
